const menu = [
  'about',
  'services',
  'our-expertise',
  'case-studies',
];
export default menu;
